module.exports = __webpack_public_path__ + "static/media/7.8c70e181.jpg";